import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Topbar from './topbar/Topbar';
import Sidebar from './sidebar/Sidebar';

import {
  changeThemeToDark, changeThemeToLight, changeThemeToSystem, syncSystemTheme
} from '../../redux/actions/themeActions';
import { changeMobileSidebarVisibility, changeSidebarVisibility } from '../../redux/actions/sidebarActions';
import { SidebarProps, ThemeProps } from '../../shared/prop-types/ReducerProps';

class Layout extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    sidebar: SidebarProps.isRequired,
    theme: ThemeProps.isRequired,
  };

  componentDidMount() {
    if (!window.matchMedia) return;
    this.systemTheme = window.matchMedia('(prefers-color-scheme: dark)');
    this.handleSystemThemeChange(this.systemTheme);
    if (this.systemTheme.addEventListener) this.systemTheme.addEventListener('change', this.handleSystemThemeChange);
    else this.systemTheme.addListener(this.handleSystemThemeChange);
  }

  componentWillUnmount() {
    if (!this.systemTheme) return;
    if (this.systemTheme.removeEventListener) this.systemTheme.removeEventListener('change', this.handleSystemThemeChange);
    else this.systemTheme.removeListener(this.handleSystemThemeChange);
  }

  handleSystemThemeChange = event => {
    const { dispatch } = this.props;
    dispatch(syncSystemTheme(event.matches));
  };

  changeSidebarVisibility = () => {
    const { dispatch } = this.props;
    dispatch(changeSidebarVisibility());
  };

  changeMobileSidebarVisibility = () => {
    const { dispatch } = this.props;
    dispatch(changeMobileSidebarVisibility());
  };

  changeToDark = () => {
    const { dispatch } = this.props;
    dispatch(changeThemeToDark());
  };

  changeToLight = () => {
    const { dispatch } = this.props;
    dispatch(changeThemeToLight());
  };

  changeToSystem = () => {
    const { dispatch } = this.props;
    dispatch(changeThemeToSystem());
  };

  render() {
    const { sidebar } = this.props;

    const layoutClass = classNames({
      layout: true,
      'layout--collapse': sidebar.collapse,
    });

    return (
      <div className={layoutClass}>
        <Topbar
          changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
          changeSidebarVisibility={this.changeSidebarVisibility}
        />
        <Sidebar
          sidebar={sidebar}
          changeToDark={this.changeToDark}
          changeToLight={this.changeToLight}
          changeToSystem={this.changeToSystem}
          changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
        />
      </div>
    );
  }
}

export default connect(state => ({
  sidebar: state.sidebar,
  theme: state.theme,
}))(Layout);
